import { render, staticRenderFns } from "./levitatedSphere.vue?vue&type=template&id=57975f24&scoped=true"
import script from "./levitatedSphere.vue?vue&type=script&lang=js"
export * from "./levitatedSphere.vue?vue&type=script&lang=js"
import style0 from "./levitatedSphere.vue?vue&type=style&index=0&id=57975f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57975f24",
  null
  
)

export default component.exports